export default "__VITE_ASSET__GQWf7$D6__"